export default __webpack_public_path__ + "static/media/Reports.Text.058c54c2.svg";